import o from"styled-components";const e=o.div`
	border-radius: ${({borderRadius:o})=>"number"==typeof o?o:14}px;
	background: ${({theme:o})=>o.bg.card};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	padding: ${({isTemplate:o})=>o?"6.371px":"14px"};
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
`;export{e as NewsContainer};
